<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Detalle de Engrane Troquel</custom-title>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconEdit"
        @click="editItem"
        >Editar</el-button
      >
    </template>
  </main-buttons-bar>

  <detail-container>
    <el-row :gutter="20">
      <custom-data
        :label="'Tipo cilindro'"
        :spanColumn="4"
        :data="cylinderAdapter.CilindroTipo?.Descripcion"
      ></custom-data>
      <custom-data
        :label="'Dientes'"
        :spanColumn="4"
        :data="cylinderAdapter.Dientes"
      ></custom-data>
      <custom-data
        :label="'Paso (mm)'"
        :spanColumn="4"
        :data="cylinderAdapter.Paso"
      ></custom-data>
    </el-row>
  </detail-container>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import { storeToRefs } from 'pinia';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomData from '@/shared/components/custom_data.vue';
import IconEdit from '~icons/mdi/edit';
import { useCylinderAdapterStore } from '../stores/cylinder_adapters_store.js';

const cylinderAdapterStore = useCylinderAdapterStore();
const { cylinderAdapter } = storeToRefs(cylinderAdapterStore);
const { findOneCilindroAdaptadorHTTP } = cylinderAdapterStore;

const route = useRoute();
const router = useRouter();

const items = [
  { label: 'Inicio', to: '/page/cylinder-adapters/list', replace: false },
  { label: 'Detalle', to: null, replace: false },
];

const editItem = () => router.replace(`/page/cylinder-adapters/edit/${route.params.id}`);

onBeforeMount(() => {
  const codigo = route.params.id;
  if (codigo && +codigo > 0) {
    findOneCilindroAdaptadorHTTP(codigo);
  }
});
</script>

<style scoped></style>
